import {withPermissionHOC} from "../../permission/components/permissionHOC/permissionHOC";
import {access_registrations} from "../../../helpers/rights";
import Box from "@mui/material/Box";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import {useEffect} from "react";
import useRegistration from "../hooks/useRegistration";
import {REGISTRATIONS} from "../locales/namespaces";
import SkeletonLoaderWrapper from "../../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper";
import MobileForm from "./mobileForm";
type Props = {};
const NewRegistration = (props: Props)=>{
    const { t } = useTranslation(REGISTRATIONS)
    let { registrationId } = useParams()
    if (!registrationId) {
        registrationId = props.registrationId
    }
    useEffect(() => {
        document.title = !registrationId ? t('New Registration') : t('Edit Registration')
    }, [])


    const {
        loading,
        registration,
        projects,
        users,
        workers,
        projectWorks
    } = useRegistration({ registrationId })

    return(
        <SkeletonLoaderWrapper loading={loading}>
            <MobileForm
                registrationId={registrationId}
                registration={registration}
                projects={projects}
                users={users}
                workers={workers}
                projectWorks={projectWorks}
            />
        </SkeletonLoaderWrapper>
    )

}
export default withPermissionHOC(NewRegistration, [access_registrations])